import { Search } from "@mui/icons-material";
import {
  Autocomplete,
  FormControl,
  IconButton,
  InputAdornment,
  Popper,
  TextField,
} from "@mui/material";
import { CustomTooltip } from "components/RosterConfig/RosterConfigStyle";
import SnackBar from "components/SnackBar/SnackBar";
import BackdropComponent from "components/Spinner/Spinner";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSupervisorDetails } from "services/centerPointUserServices";
import { SnackBarStoreAction } from "Store/SnackBar";
import PropTypes from "prop-types";
const initialSelectedSupervisorState = {
  EmployeeId: 0,
  OracleId: "",
  FirstName: "",
  LastName: "",
  EmployeeStatus: "",
  JobTitle: "",
  Name: "",
  Display: "",
};

export const CustomPopper = (props) => {
  return <Popper {...props} placement="bottom-start" />;
};
export default function SupervisorSearch(props) {
  const { onChange, label, onReset, disabled, defaultSupervisorName } = props;
  const [loading, setLoading] = useState(false);
  const [supervisorResults, setSupervisorResults] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState({
    ...initialSelectedSupervisorState,
    Name: defaultSupervisorName,
    Display: defaultSupervisorName,
  });

  useEffect(() => {
    setSelectedSupervisor({
      ...selectedSupervisor,
      Name: defaultSupervisorName,
      Display: defaultSupervisorName,
    });
  }, [defaultSupervisorName]);
  const dispatch = useDispatch();

  const showSnack = (message, severity) => {
    const obj = {
      open: true,
      message: message,
      severity: severity,
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleSupervisorSearchInputChange = (key, value) => {
    setSelectedSupervisor((prevState) => ({ ...prevState, [key]: value }));
  };

  const handleSupervisorSelected = (event, value) => {
    if (value) {
      setSelectedSupervisor({
        EmployeeId: value.EmployeeId,
        OracleId: value.OracleId,
        FirstName: value.FirstName,
        LastName: value.LastName,
        EmployeeStatus: value.EmployeeStatus,
        JobTitle: value.JobTitle,
        Name: value.FirstName + " " + value.LastName,
        Display: value.Display,
      });
      onChange(value);
    }
  };

  const handleSupervisorSearch = async (event, searchQuery) => {
    if (searchQuery) {
      if (searchQuery.length < 3) {
        showSnack(
          "Search criteria must be at least 3 characters in length.",
          "error"
        );
        return;
      }
      setLoading(true);
      const searchResult = await getSupervisorDetails(searchQuery);
      const searchResultResponse = searchResult?.data;

      if (searchResultResponse.status === true) {
        let searchResultDetails;

        if (!isNaN(searchQuery)) {
          searchResultDetails = searchResultResponse?.data?.map((emp) => ({
            EmployeeId: emp.EmployeeId,
            OracleId: emp.OracleId,
            FirstName: emp.FirstName,
            LastName: emp.LastName,
            EmployeeStatus: emp.EmployeeStatus,
            JobTitle: emp.JobTitle,
            Name: emp.FirstName + " " + emp.LastName,
            Display:
              emp.FirstName + " " + emp.LastName + "(" + emp.OracleId + ")",
          }));
        } else {
          searchResultDetails = searchResultResponse.data.map((emp) => ({
            EmployeeId: emp.EmployeeId,
            OracleId: emp.OracleId,
            FirstName: emp.FirstName,
            LastName: emp.LastName,
            EmployeeStatus: emp.EmployeeStatus,
            JobTitle: emp.JobTitle,
            Name: emp.FirstName + " " + emp.LastName,
            Display: emp.FirstName + " " + emp.LastName,
          }));
        }

        setSupervisorResults(searchResultDetails);

        showSnack("Results found matching the search criteria.", "success");
      } else {
        setSnack("No result found matching with search criateria.", "error");
      }
      setLoading(false);
    }
  };

  const handleReset = (event, value) => {
    if (value === "") {
      onReset(initialSelectedSupervisorState);
      setSelectedSupervisor(initialSelectedSupervisorState);
      setSupervisorResults([]);
    }
  };

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <FormControl fullWidth>
        <Autocomplete
          freeSolo
          label={label}
          disabled={disabled}
          required
          options={supervisorResults}
          getOptionLabel={(option) => option.Display || ""}
          onInputChange={handleReset}
          onChange={handleSupervisorSelected}
          inputValue={selectedSupervisor.Name || ""}
          PopperComponent={CustomPopper}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              label={label}
              size="small"
              variant="outlined"
              value={selectedSupervisor.Name || ""}
              onChange={(event) =>
                handleSupervisorSearchInputChange("Name", event.target.value)
              }
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  handleSupervisorSearch(event, selectedSupervisor.Name);
                }
              }}
              InputProps={{
                maxLength: 50,
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    <CustomTooltip title={"Search"}>
                      <IconButton
                        id="icon-button-search"
                        type="button"
                        onClick={(event) =>
                          handleSupervisorSearch(event, selectedSupervisor.Name)
                        }
                        color="primary"
                      >
                        <Search />
                      </IconButton>
                    </CustomTooltip>
                    {params.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </FormControl>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
}

SupervisorSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  onReset: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  defaultSupervisorName: PropTypes.string.isRequired,
};
